import s from './Contact.module.css';
import { usePathname } from 'next/navigation';
import { motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
import { useTranslations } from 'next-intl';

// ssr: false para que Next no precargue estos chunks desde el HTML. El form
// nunca se renderiza en el servidor (shouldLoadForm arranca en false), pero
// sin esto igual se bajaban Formik, Yup y el script de Google en cada pagina.
const ContactForm = dynamic(() => import('@/components/ContactForm'), { ssr: false });
// El provider monta el script de reCAPTCHA de Google (347 KB). Va junto al
// formulario y no en el layout raiz: ahi se cargaba en todas las paginas.
const RecaptchaProvider = dynamic(() => import('@/components/RecaptchaProvider'), {
  ssr: false
});

const Contact = () => {
  const pathname = usePathname();
  const t = useTranslations('contact');
  const [shouldLoadForm, setShouldLoadForm] = useState(false);
  const sectionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section || shouldLoadForm) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry?.isIntersecting) {
          setShouldLoadForm(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, [shouldLoadForm]);

  return (
    <motion.div
      ref={sectionRef}
      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.2 } }}
      className={s.container}
      id="contact">
      {pathname != '/contacto' && pathname != '/en/contacto' && (
        <h3 className={s.container__title}>{t('title')}</h3>
      )}
      <p className={s.container__text}>{t('description')}</p>
      {shouldLoadForm ? (
        <RecaptchaProvider>
          <ContactForm />
        </RecaptchaProvider>
      ) : (
        <div style={{ minHeight: 280 }} aria-hidden="true" />
      )}
    </motion.div>
  );
};

export default Contact;
